import React from 'react';
import { useViewport } from 'hooks/3catinfo/useViewport';
import { getDataUTC, is3CatInfoVerificacio } from '@portal-internet/core';
import { getNaturalDate } from 'utils/3catinfo/dateHelper';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import IconaMedia from 'components/3catinfo/IconaMedia';
import Etiqueta from 'components/3catinfo/Etiqueta';
import Etiquetes from 'components/3catinfo/Etiquetes';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatHoritzontal.module.scss';

const Avantitol = (props) => {
    const { mostraComarca, mostraPrograma, mostraTematica, item } = props;
    const { programes_tv, programes_radio, tags, comarques } = item;

    const programa = programes_tv?.[0]?.desc || programes_radio?.[0]?.desc;
    const comarca = comarques?.[0]?.desc;
    const mainTheme = tags?.find((t) => t.main)?.desc?.toUpperCase();
    const isVerifica = is3CatInfoVerificacio(tags);

    return (
        <>
            {isVerifica && <div className={styles.avantitol}>3catinfo verifica</div>}
            {!isVerifica && mostraComarca && comarca && <div className={styles.avantitol}>{comarca}</div>}
            {mostraTematica && mainTheme && <span className={styles.tematica}>{mainTheme}</span>}
            {!isVerifica && mostraPrograma && programa && <div className={styles.avantitol}>{programa}</div>}
        </>
    );
};

const Peu = (props) => {
    const { lloc, autors, programa } = props;

    const stylesPeu = clsx({
        [styles.lloc]: true,
        [styles.ambAutor]: !__isEmpty(programa) || !__isEmpty(autors)
    });

    if (__isEmpty(lloc) && __isEmpty(autors)) return <></>;

    return (
        <div>
            {!__isEmpty(autors) && (
                <span className={styles.autors}>
                    {autors.map((item, i) => {
                        const isFirst = i === 0 && autors.length > 1;
                        const isLast = i === autors.length - 1;
                        const routeAutor = { slug: item?.nom, id: item?.id, tipologia: item?.tipologia };
                        return (
                            <React.Fragment key={item.id}>
                                {!isLast && !isFirst && ', '}
                                {isLast && autors.length > 1 && ' i '}
                                <Enllac route={routeAutor} className={styles.enllacAutor}>
                                    {item.nom}
                                </Enllac>
                            </React.Fragment>
                        );
                    })}
                </span>
            )}
            {!__isEmpty(lloc) && <span className={stylesPeu}>{lloc}</span>}
        </div>
    );
};

const DestacatHoritzontal = (props) => {
    const {
        item,
        positionImg,
        estil,
        inMosaic,
        routePath,
        testId,
        numColumnsRow,
        tag = 'h3',
        mostraComarca,
        mostraPrograma,
        mostraTematica,
        mostrarData,
        marcatgeAudienciesClick
    } = props;
    const {
        id,
        domini,
        titol,
        lloc,
        permatitle,
        imatges,
        tipologia,
        agrupacions,
        tags,
        autors,
        href,
        imatgeSrc,
        imatgeAlt,
        programes_tv,
        programes_radio,
        data_publicacio
    } = item;
    const { videos, audios, canals_directes_embedats, mediadestacat } = item || props;
    const { viewport, zoomNavigator, isMobile, typesViewport } = useViewport();
    const TagSeo = tag;
    const programa = programes_tv?.[0]?.desc || programes_radio?.[0]?.desc;
    const route = { slug: permatitle || titol, id: id, tipologia: tipologia, type: routePath, href: href, domini };

    const stylesDestacat = clsx({
        [styles.destacat]: true,
        [styles.inMosaic]: inMosaic,
        [styles.right]: positionImg === 'right',
        [styles.ambZoom]: !isMobile && zoomNavigator > 1.5,
        [styles[estil]]: !!estil
    });

    const DataPublicacio = (props) => {
        const { mostrarData, date } = props;
        return mostrarData && date ? (
            <time dateTime={getDataUTC(date)} className={styles.dataPub}>
                {getNaturalDate(date)}
            </time>
        ) : (
            <></>
        );
    };

    const etiqueta = canals_directes_embedats ? (
        <div className={styles.labelWrapper} data-testid='etiqueta'>
            <Etiqueta className={styles.labelDirecte} text='En directe' icona='directes' isBlanc={true} tipus='highlight' />
        </div>
    ) : (
        <div className={styles.labelWrapper} data-testid='etiqueta'>
            <Etiquetes agrupacions={agrupacions} tags={tags} id={id} />
        </div>
    );

    const tipusImatge =
        viewport === typesViewport.VP_SMALL && estil !== 'fixHoritzontal' ? 'web_destacat' : 'web_destacat_horitzontal';

    return item ? (
        <article className={stylesDestacat} {...(testId && { 'data-testid': testId })}>
            <div className={styles.wrapper}>
                <div className={styles.imatgeWrapper} data-testid='destacat-content-imatge'>
                    {etiqueta}

                    <IconaMedia
                        videos={videos}
                        audios={audios}
                        canals_directes_embedats={canals_directes_embedats}
                        mediadestacat={mediadestacat}
                    />
                    <Imatge
                        className={styles.imatge}
                        imatges={imatges}
                        src={imatgeSrc}
                        alt={imatgeAlt}
                        tipus={tipusImatge}
                        layout='fill'
                        objectFit='cover'
                        numColumnsRow={numColumnsRow}
                        data_testid='destacat-img'
                    />
                </div>
            </div>
            <div className={styles.title} data-testid='destacat-titol'>
                <Avantitol
                    mostraComarca={mostraComarca}
                    mostraPrograma={mostraPrograma}
                    mostraTematica={mostraTematica}
                    item={item}
                />
                <TagSeo className={styles.titol}>
                    <Enllac
                        route={route}
                        dataTestId='destacat-enllac'
                        marcatgeAudienciesClick={marcatgeAudienciesClick}
                        className={styles.enllac}
                    >
                        <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                    </Enllac>
                </TagSeo>
                <DataPublicacio isDirecte={false} mostrarData={mostrarData} date={data_publicacio} className={styles.dataPub} />
                <Peu lloc={lloc} autors={autors} programa={programa} />
            </div>
        </article>
    ) : (
        <></>
    );
};

export default DestacatHoritzontal;
